export default "__VITE_ASSET__4442d4a6__"